"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pwdOnly10Numbers = exports.pwdChars8letters1numbers1 = void 0;
// 8 chars long, one uppercase, one number
exports.pwdChars8letters1numbers1 = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/);
// Only 10 numeric chars
exports.pwdOnly10Numbers = new RegExp(/^[0-9]{1,10}$/);
